var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 30,
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-4.1538086 -0.6923828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7776 17.1768L13.041 16.9134C13.2155 16.7389 13.2155 16.4559 13.041 16.2813L5.75965 8.99998L13.041 1.71864C13.2155 1.5441 13.2155 1.26111 13.041 1.08654L12.7776 0.823208C12.6031 0.648674 12.3201 0.648674 12.1455 0.823208L4.28475 8.68395C4.11021 8.85849 4.11021 9.14148 4.28475 9.31605L12.1455 17.1768C12.3201 17.3513 12.6031 17.3513 12.7776 17.1768Z",
    id: "Icon-Color",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.a2aa4c169c0bf0d0113f13c1718fd282.svg";
export { ForwardRef as ReactComponent };